"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.reinitIframe = exports.windowAddEventListener = exports.throttle = exports.scaleAnimation = exports.fomateFileData = exports.LIVE_TYPE = void 0;
// 动效图支持类型
exports.LIVE_TYPE = [
    'activityBanner',
    'student',
    'customers',
    'pricing',
    'partner',
    'sme',
    'audiovb',
    'startup',
    'supportPlan',
    'supportSecurity',
    'freetier',
    'sale',
];
/*
 * 资源文件处理，alt
 */
var fomateFileData = function (val) {
    try {
        var data = JSON.parse(val);
        return data;
    }
    catch (err) {
        return { url: val, alt: '' };
    }
};
exports.fomateFileData = fomateFileData;
/*
 * VOD视频上传数据处理
 */
var fomateVodData = function (val) {
    try {
        var data = JSON.parse(val);
        return data;
    }
    catch (err) {
        return { url: val };
    }
};
var scaleAnimation = function (str) {
    var schd = document.querySelector("#".concat(str));
    var windowWidth = window.innerWidth;
    var domeWidthValue = 768;
    var scale = 1;
    if (windowWidth < domeWidthValue) {
        scale = 375 / domeWidthValue;
    }
    else {
        scale = windowWidth / domeWidthValue > 1 ? 1 : windowWidth / domeWidthValue;
    }
    schd.style.transform = "scale(".concat(scale, ") translate(-50%, -50%)");
};
exports.scaleAnimation = scaleAnimation;
var queuePerformTask = new WeakMap();
function initCompute(callback) {
    var contentWidth = window.innerWidth;
    if (contentWidth > 768) {
        callback(true, contentWidth);
    }
    else {
        callback(false, contentWidth);
    }
}
function throttle(callback, delay) {
    var timeout = null;
    return function () {
        if (timeout)
            clearTimeout(timeout);
        timeout = setTimeout(function () {
            timeout = null;
            callback === null || callback === void 0 ? void 0 : callback();
        }, delay || 3000);
    };
}
exports.throttle = throttle;
function windowAddEventListener(callback, delay) {
    if (!queuePerformTask.get(callback)) {
        queuePerformTask.set(callback, callback);
    }
    initCompute(callback);
    window.addEventListener('resize', throttle(function () {
        initCompute(callback);
    }, delay || 1000));
}
exports.windowAddEventListener = windowAddEventListener;
var nowDate = new Date().getTime();
function reinitIframe(props) {
    var _a = props || {}, filedVideoBg = _a.filedVideoBg, filedVideoList = _a.filedVideoList, postMessageUrl = _a.postMessageUrl;
    var iframe = document.getElementById('frame_child_content');
    var _b = fomateVodData(filedVideoList), url = _b.url, id = _b.id;
    var filedVideoBgUrl = (0, exports.fomateFileData)(filedVideoBg).url;
    function requestAnimationRequestFunc() {
        var _a;
        if (new Date().getTime() - nowDate >= 2000) {
            (_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage({
                status: '1',
                filedVideoBg: filedVideoBgUrl,
                filedVideoList: id || url,
            }, postMessageUrl || 'https://intl.cloud.tencent.com/solution-new/tcp-player'); // 父向子传递
            window.addEventListener('message', function (event) {
                // 父获取子传递的消息
                var iframe = document.getElementById('frame_child_content');
                if (event.data === '1') {
                    iframe.style.display = 'none';
                }
            }, false);
        }
        else {
            requestAnimationRequestFunc();
        }
    }
    requestAnimationRequestFunc();
    try {
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.style.display = 'block';
    }
    catch (ex) { }
}
exports.reinitIframe = reinitIframe;
//# sourceMappingURL=index.js.map